import { useState } from 'react';
import { Button, Input, message } from 'antd';

interface Props {
  product: 'vedic' | 'career' | 'talent-kid';
  reportToken: string;
  userId?: string;
  recordId?: string;
  onUnlocked: (answer: string, generating?: boolean) => void;
}

export default function InviteCodeUnlock({ product, reportToken, userId, recordId, onUnlocked }: Props) {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const redeem = async () => {
    if (loading || !reportToken) return;
    if (!code.trim()) { message.warning('请输入邀请码'); return; }
    setLoading(true);
    try {
      const response = await fetch('/api/invite-code', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'redeem', type: product, code: code.trim(), reportToken, userId, recordId }),
      });
      const result = await response.json();
      if (!response.ok || !result.success || (!result.answer && !result.generating)) throw new Error(result.error || '邀请码解锁失败');
      onUnlocked(result.answer || '', Boolean(result.generating));
      message.success(result.generating ? '已解锁，正在接入完整正文，后续内容将持续显示' : '邀请码解锁成功，完整报告已解锁');
    } catch (error) {
      message.error(error instanceof Error ? error.message : '解锁失败，请稍后重试');
    } finally { setLoading(false); }
  };

  return <div style={{ marginTop: 20 }}>
    <p>有邀请码？印占、事业、子女天赋通用，每解锁一份报告使用一次。</p>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
      <Input aria-label="邀请码" placeholder="请输入邀请码" value={code} maxLength={128}
        disabled={loading || !reportToken} onChange={(event) => setCode(event.target.value)} onPressEnter={redeem}
        style={{ flex: '1 1 180px', minWidth: 0 }} />
      <Button onClick={redeem} loading={loading} disabled={!reportToken}>使用邀请码解锁</Button>
    </div>
  </div>;
}
